import { RecordScreen } from "@/lib/Components/Screens/RecordScreen/RecordScreen";
import {
  BuildingOffice2Icon,
  ClockIcon,
  CurrencyDollarIcon,
  DocumentTextIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { ImageIcon, PencilIcon } from "lucide-react";
import { useOrganisationRecord } from "@/app/Organisations/Hooks/useOrganisationRecord";
import { useOrganisationActions } from "@/app/Organisations/Hooks/useOrganisationActions";
import { Badge } from "@/components/catalyst/badge";
import { Avatar } from "@/components/catalyst/avatar";
import { UploadMediaDialog } from "@/app/Media/Components/UploadMediaDialog";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { MediaCollection, ModelType } from "@/gql/graphql";

export function OrganisationRecordScreen() {
  const record = useOrganisationRecord();
  const getActions = useOrganisationActions();
  const uploadDialog = useDialog(UploadMediaDialog);
  const contactId = record.contact?.id;

  return (
    <RecordScreen
      tabParams={{ id: record.id }}
      title={record.name}
      image={
        contactId ? (
          <button
            onClick={() =>
              uploadDialog.open({
                objectId: contactId,
                objectType: ModelType.Contact,
                collection: MediaCollection.ProfilePicture,
              })
            }
            className="group relative cursor-pointer"
          >
            {record.profilePicture ? (
              <>
                <Avatar
                  media={record.profilePicture}
                  initials={record.name}
                  className="size-20"
                />
                <div className="absolute inset-0 flex items-center justify-center rounded-full bg-black/50 opacity-0 transition-opacity group-hover:opacity-100">
                  <PencilIcon className="size-8 text-white" />
                </div>
              </>
            ) : (
              <div className="flex size-20 items-center justify-center rounded-full border-2 border-dashed border-gray-300 bg-gray-50 transition-colors group-hover:border-gray-400 group-hover:bg-gray-100">
                <ImageIcon className="size-8 text-gray-400 group-hover:text-gray-600" />
              </div>
            )}
          </button>
        ) : null
      }
      actionsGroups={getActions(record)}
      badges={
        record.is_verified ? (
          <Badge color="green">Verified</Badge>
        ) : (
          <Badge color="zinc">Unverified</Badge>
        )
      }
      tabs={[
        {
          name: "Details",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/organisations/$id",
          Icon: DocumentTextIcon,
        },
        {
          name: "Members",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/organisations/$id/members",
          Icon: UsersIcon,
        },
        {
          name: "Suppliers",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/organisations/$id/suppliers",
          Icon: BuildingOffice2Icon,
        },
        {
          name: "Invoices",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/organisations/$id/invoices",
          Icon: CurrencyDollarIcon,
        },
        {
          name: "Activity",
          to: "/$tenant/$orgId/supplier/{-$supplierId}/organisations/$id/activity",
          Icon: ClockIcon,
        },
      ]}
    />
  );
}
